import React from 'react';
import { Image } from '@react-pdf/renderer';
import { appConfig } from 'src/config';

export default function Background() {
  return (
    <Image
      src={`${appConfig.backendRootUrl}/static-backend/ghg_certificate.png`}
      style={{
        position: 'absolute',
        height: '100vh',
        width: '100vw',
      }}
    />
  );
}
